import { createAction, createSlice, PayloadAction } from '@reduxjs/toolkit';

import { AppUITheme, TContactUsDTO, TTaskStatus } from '../types';

export type LayoutState = {
  currentTheme: AppUITheme;
  taskStatus: TTaskStatus;
  isSuccess: boolean;
};

const createLayoutSlice = (initialState: LayoutState) =>
  createSlice({
    name: 'layout',
    initialState,
    reducers: {
      setLayoutTheme(state, { payload }: PayloadAction<AppUITheme>) {
        state.currentTheme = payload;
      },

      startTask(state) {
        state.taskStatus = 'pending';
      },

      endTask(state) {
        state.taskStatus = 'idle';
      },

      onSuccess(state) {
        state.isSuccess = true;
      },

      clearSuccess(state) {
        state.isSuccess = false;
      },
    },
  });

const layoutSlice = createLayoutSlice({
  currentTheme: AppUITheme.NA,
  taskStatus: 'idle',
  isSuccess: false,
});

export const contactUsRequest = createAction<TContactUsDTO>('contactUsRequest');

export const { setLayoutTheme, endTask, startTask, clearSuccess, onSuccess } =
  layoutSlice.actions;
export default layoutSlice.reducer;
